import { DateFnsDatePicker } from '../Pickers';
import { usePickerLocale } from '../../pages/homework/usePickerLocale';
import { PICKER_DATE, PICKER_DATE_TIME } from './dates';

/**
 * The one date picker of the tool sections (design §1.6): a thin wrapper over `DateFnsDatePicker` that fixes the locale, the format and
 * the width — nothing that could fight the picker's own popup fix (N-10). Clock times without a date (bedtime, rise time) stay text
 * inputs; this is for DATES.
 */
export type ToolDatePickerProps = {
  value: Date | null;
  onChange: (d: Date | null) => void;
  showTime?: { minuteStep: 5 };
  disabledDate?: (d: Date) => boolean;
  testId?: string;
  placeholder?: string;
  allowClear?: boolean;
};

export const ToolDatePicker = ({
  value,
  onChange,
  showTime,
  disabledDate,
  testId,
  placeholder,
  allowClear = false,
}: ToolDatePickerProps) => {
  const locale = usePickerLocale();
  return (
    <DateFnsDatePicker
      locale={locale}
      style={{ width: '100%' }}
      format={showTime ? PICKER_DATE_TIME : PICKER_DATE}
      showTime={showTime ? { format: 'HH:mm', ...showTime } : undefined}
      allowClear={allowClear}
      placeholder={placeholder}
      value={value}
      disabledDate={disabledDate}
      onChange={(d: Date | null) => onChange(d)}
      data-testid={testId}
    />
  );
};
